<template>
  <div></div>
</template>
<script>
import { MESSAGE_EVENTS } from '@/constants/messageEventsConstants';
import { postMessage } from '@/utils/message/postMessage';
import { defineComponent } from '@vue/composition-api';
export default defineComponent({
  name: 'CorpNiceAuth',
  data() {},
  mounted() {
    postMessage({
      type: MESSAGE_EVENTS.NICE_SUCCESS,
      url: window.location.href,
    });
    window.close();
  },
  methods: {},
});
</script>
